import { withAuthenticatedLayout } from '../../components/layouts/layout'
import { useAppState } from '../../state'
import { V3DashboardBasePageOld } from './v3-dashboard-page-old'
import { V3DashboardBasePageRedesign } from './v3-dashboard-page-redesign'

export const V3DashboardBasePage: React.FC = () => {
  const { isClassicView } = useAppState()

  return isClassicView ? <V3DashboardBasePageOld /> : <V3DashboardBasePageRedesign />
}

export const V3DashboardPage = withAuthenticatedLayout(V3DashboardBasePage)
